export default __webpack_public_path__ + "static/media/factory__23.e60e8297.jpg";